import { DocumentType, gql } from '@/__generated__/gql'

export const ContentPolicyListYIQuery = gql(`
    query ContentPolicyList_YIQuery {
      contentPolicyList(limit: 1000){
        contentPolicies{
          policyId
          name
        }
      }
    }
`)

export type RawData = DocumentType<typeof ContentPolicyListYIQuery>
